import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PauseIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pause"}/>
}
